export class Partition {
  id!: number;
  name: string = '';
  parentId?: number;
  active: boolean = true;
  notes?: string;

  additionalInfo?: PartitionAdditionalInfo;

  isConnected?: boolean;
}

class PartitionAdditionalInfo {
  address?: Address;
}

class Address {
  number?: string;
  street?: string;
  city?: string;
  cap?: string;
  telephone?: string;
  province?: string;
}
